<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part" id="part1"><a id="page_16"></a><a id="page_17"></a>PART ONE<br/><span class="big2">Lovers &amp; Strangers</span></h1>
<div class="block">
<p class="nonindent1">Call no man foe, but never love a stranger.</p>
<p class="right1">S<span class="small">TELLA</span> B<span class="small">ENSON</span></p>
<p class="nonindent1">Be not forgetful to entertain strangers: for thereby some have entertained angels unawares.</p>
<p class="right1">T<span class="small">HE</span> B<span class="small">IBLE:</span> H<span class="small">EBREWS</span></p>
<p class="nonindent1">My true-love hath my heart, and I have his,<br/>By just exchange one for the other given:<br/>I hold his dear, and mine he cannot miss,<br/>There never was a better bargain driven.</p>
<p class="right1">S<span class="small">IR</span> P<span class="small">HILIP</span> S<span class="small">IDNEY</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-part1.vue?29e3598a